import { PermissionAccess } from '@symfa-inc/providence-types';

export const canBeEditable = (
  fieldPermission?: PermissionAccess,
  isEditing?: boolean,
): boolean =>
  fieldPermission ? !!isEditing : !!isEditing && !!fieldPermission;
